import { render, staticRenderFns } from "./ArticleContributors.vue?vue&type=template&id=56ab2c19&scoped=true&"
import script from "./ArticleContributors.vue?vue&type=script&lang=ts&"
export * from "./ArticleContributors.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleContributors.vue?vue&type=style&index=0&id=56ab2c19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab2c19",
  null
  
)

export default component.exports